import { render, staticRenderFns } from "./Actualities.vue?vue&type=template&id=9421bc44&scoped=true"
import script from "./Actualities.vue?vue&type=script&lang=js"
export * from "./Actualities.vue?vue&type=script&lang=js"
import style0 from "./Actualities.vue?vue&type=style&index=0&id=9421bc44&prod&lang=scss"
import style1 from "./Actualities.vue?vue&type=style&index=1&id=9421bc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9421bc44",
  null
  
)

export default component.exports